import { useQuery } from '@tanstack/react-query';
import apiClient from '../lib/api-client';

const useGetInvestmentStatement = (policyNumber, enabled, basePath = 'life') => {
  const isValidPolicyNumber = policyNumber && typeof policyNumber === 'string' && policyNumber.trim() !== '';

  return useQuery({
    queryKey: ['investmentStatement', policyNumber],
    queryFn: async () => {
      if (!isValidPolicyNumber) {
        throw new Error('Invalid or missing policy number');
      }
      const response = await apiClient.get(`/${basePath}/investment-report`, {
        params: { policy_number: policyNumber },
      });
      return response.data;
    },
    enabled: enabled && isValidPolicyNumber,
    retry: (failureCount, error) => {
      if (error?.message === 'Invalid or missing policy number') return false;
      return failureCount < 3;
    },
  });
};

export { useGetInvestmentStatement };